import React from 'react';
import { OverlayView } from 'react-google-maps';

import SubjectPin from 'assets/images/investor-subject-pin.svg';

import css from './style.scss';

// The searched property on its own — the star pin (Figma 231:8427) at the
// location the search service geocoded (ATAI-316).
//
// buildInvestorPins only stars an investor's pin when the subject property is
// that investor's anchor property, and the search response often doesn't
// include the subject among the investors' properties at all, so the subject
// went unmarked. InvestorMap draws this one whenever no investor pin is
// already the subject. It is a plain marker, not an investor: no card, no click.
//
// Same tip-on-coordinate offset as InvestorMarker, so both pins sit alike.
const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -height,
});

const SubjectMarker = ({ position }) => (
  <OverlayView
    position={position}
    mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    getPixelPositionOffset={getPixelPositionOffset}
  >
    <div className={css.marker}>
      <div className={css.pin} style={{ cursor: 'default' }} title="Subject Property">
        <img src={SubjectPin} alt="Subject Property" className={css.pin__subject} />
      </div>
    </div>
  </OverlayView>
);

export default SubjectMarker;
